import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { ServicesSection } from '../components/ServicesSection';
import { BookingCTA } from '../components/BookingCTA';
export function ServicesPage() {
  return <>
      <PageBanner title="Our Services" subtitle="Expertly crafted styles tailored to enhance your natural beauty and protect your hair." backgroundImage="https://cdn.magicpatterns.com/uploads/oPcjCp9rNhyi11miaW2wZo/istockphoto-1618291225-612x612.webp" data-id="element-365" />
      <ServicesSection data-id="element-366" />
      <BookingCTA data-id="element-367" />
    </>;
}